import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";

@Component({
    selector: "eff-icon",
    templateUrl: "./eff-icon.component.html",
    styleUrls: ["./eff-icon.component.scss"],
    imports: [CommonModule, MatIconModule]
})
export class EffIconComponent {
    @Input() icon: string;
    @Input() size: string = "medium-size";
}
